export const getGridColumnsString = (config, dragable) => {
    return `${dragable ? '1fr ' : ''}${config.columns.map(({ flex }) => `${flex}fr`).join(' ')}`
}